import { combineReducers } from '@reduxjs/toolkit';
import client from './clientSlice';
import clientTasks from '../tasks/store/clientTasksSlice';

const reducer = combineReducers({
  client,
  clientTasks,
});

export default reducer;
